import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children, allowedRoles }) => {
  const isLoggedIn = localStorage.getItem("adminAuth");

  if (!isLoggedIn) {
    return <Navigate to="/login" />;
  }

  if (allowedRoles) {
    const role = localStorage.getItem("adminRole") || "superadmin";
    if (!allowedRoles.includes(role)) {
      return <Navigate to="/admin" />;
    }
  }

  return children;
};

export default ProtectedRoute;
